import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './styles.css';


const VerticalCarousel = ({links}) => {

  const imgCDNURL = process.env.REACT_APP_AIWORKSHOPFEEDBACK_CDN_URL;
  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      swipeable
      emulateTouch
      verticalSwipe
      infiniteLoop
      interval={3000}
      autoPlay
      showIndicators={false}
      showArrows={false}
      stopOnHover
      transitionTime={500}
      selectedItem={0}
      axis="vertical"
      className="carousel-wrapper"
    >
      <div className="slide">
        <img src={imgCDNURL + "Image1.webp"} className="Image1" alt="Share Your Feedback on Our Ai Workshops
to Help Us Improve" />
        <img src={imgCDNURL + "Image1m.webp"} className="Image1m" alt="Share Your Feedback on Our Ai Workshops
to Help Us Improve" />
      </div>
      <div className="slide">
      <a href={links.current.brandURL}
          target="_blank"
          rel="noreferrer noopener">
        <video className='videoTag' autoPlay muted loop playsInline>
          <source
            src={imgCDNURL + "Image2.mp4"}
            type='video/mp4'
            alt="The Lending and Banking Experience Is Often Difficult, Complex and Unfair." />
        </video>
        </a>
      </div>
      <div className="slide">
        <a href="https://www.swmc.com/angelai-university/"
          target="_blank"
          rel="noreferrer noopener">
          <img src={imgCDNURL + "Image3.webp"} className="Image3" alt="Attention Brokers And Agents" />
        </a>
      </div>
      <div className="slide">
        <a href="https://www.angelai.com/aisign/"
          target="_blank"
          rel="noreferrer noopener">
          <video className='videoTag' autoPlay muted loop playsInline>
            <source
              src={imgCDNURL + "Image4.mp4"}
              type='video/mp4'
              alt="AI Sign" />
          </video>
        </a>
      </div>
      <div className="slide">
        <a href={links.current.brandURL}
          target="_blank"
          rel="noreferrer noopener">
          <img src={imgCDNURL + "Image5.webp"} className="Image5" alt="What can AngelAi do for You" />
        </a>
      </div>
    </Carousel>
  );
};

export default VerticalCarousel;
